import { type RouteObject } from 'react-router-dom';

import { ROUTES_PATH } from '@/constants/routes.constants';

const UsageGuideRoutes: RouteObject[] = [
  { path: ROUTES_PATH.usageGuide, lazy: () => import('./dashboard') },
];

export { UsageGuideRoutes };
